import { render, staticRenderFns } from "./GamesPlayer.vue?vue&type=template&id=5e141061&"
import script from "./GamesPlayer.vue?vue&type=script&lang=js&"
export * from "./GamesPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports